export default __webpack_public_path__ + "static/general-pest-6db82bde21787a25ee333310d80ad084.png";